import { styled, typography } from '@pulse-web-ui/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
`;

export const LabelHighlight = styled.span`
  color: ${({ theme }) => theme.colors.text.interactive};
`;

export const Description = styled.p`
  ${typography.regular16}
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 24px;
`;

export const PrimaryText = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const HintContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.text.secondary};

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 5px;
  }
`;
